import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { paginationShape } from '@bibliocommons/bc-prop-types';

import HoldActions from '../actions/HoldActions';
import * as HoldsSelector from '../selectors/HoldsSelector';
import { getBibsByMetadataId } from '../selectors/BibSelector';
import { currentAccountSelector } from '../selectors/AuthSelector';

import HoldsToReview from '../components/borrowing/holds/HoldsToReview';
import { currentLibrarySelector } from '../selectors/LibrarySelector';

export class HoldsContainer extends BcReactComponent {
  render() {
    return this.props.showInactiveHolds && (
      <HoldsToReview
        expiredCount={this.props.expiredCount}
        cancelledCount={this.props.cancelledCount}
        expiredHolds={this.props.expiredHolds}
        cancelledHolds={this.props.cancelledHolds}
        fetchingExpired={this.props.fetchingExpired}
        fetchingCancelled={this.props.fetchingCancelled}
        fetchExpiredHolds={this.props.holdActions.fetchExpiredHolds}
        fetchCancelledHolds={this.props.holdActions.fetchCancelledHolds}
        cancelledHoldsPagination={this.props.cancelledHoldsPagination}
        expiredHoldsPagination={this.props.expiredHoldsPagination}
        accountId={this.props.accountId}
        bibs={this.props.bibs} />
    );
  }
}

const mapStateToProps = (state) => {
  const library = currentLibrarySelector(state);
  const showInactiveHolds = library.get('showInactiveHolds', false);
  const bibs = getBibsByMetadataId(state);

  const holdCounts = HoldsSelector.getInactiveHoldCountsByStatus(state);
  const inactiveHoldData = HoldsSelector.getInactiveHoldData(state);
  const accountId = currentAccountSelector(state).get('id');

  return {
    expiredCount: holdCounts.get('EXPIRED', 0),
    cancelledCount: holdCounts.get('CANCELLED', 0),
    expiredHolds: HoldsSelector.getExpiredHolds(state),
    cancelledHolds: HoldsSelector.getCancelledHolds(state),
    showInactiveHolds,
    fetchingExpired: inactiveHoldData.getIn(['expired', 'fetching']),
    fetchingCancelled: inactiveHoldData.getIn(['cancelled', 'fetching']),
    bibs,
    cancelledHoldsPagination: inactiveHoldData.getIn(['cancelled', 'pagination']),
    expiredHoldsPagination: inactiveHoldData.getIn(['expired', 'pagination']),
    accountId
  };
};

HoldsContainer.propTypes = {
  expiredCount: PropTypes.number,
  cancelledCount: PropTypes.number,
  holdActions: PropTypes.objectOf(PropTypes.func),
  cancelledHoldsPagination: paginationShape,
  expiredHoldsPagination: paginationShape,
  accountId: PropTypes.number
};

const mapDispatchToProps = dispatch => ({
  holdActions: bindActionCreators(HoldActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(HoldsContainer);



// WEBPACK FOOTER //
// ./app/containers/HoldsToReviewContainer.jsx